import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

interface TableTabsProps {
    /** Current monitoring filter; `true` = monitored, `false` = not monitored, `null` = all */
    filterMonitored: boolean | null
}

/**
 * Navigation tabs that switch between monitored / not-monitored / all-devices views.
 */
const TableTabs = ({ filterMonitored }: TableTabsProps) => {
    const { t } = useTranslation()
    return (
        <ul className="nav nav-tabs">
            <li className="nav-item">
                <Link
                    className={classnames({
                        'nav-link text-800': true,
                        'active': filterMonitored === true,
                    })}
                    to="/devices"
                >
                    {t('device.monitored')}
                </Link>
            </li>
            <li className="nav-item">
                <Link
                    className={classnames({
                        'nav-link text-800': true,
                        'active': filterMonitored === false,
                    })}
                    to="/devices/not-monitored"
                >
                    {t('device.notMonitored')}
                </Link>
            </li>
            <li className="nav-item">
                <Link
                    className={classnames({
                        'nav-link text-800': true,
                        'active': filterMonitored === null,
                    })}
                    to="/devices/all"
                >
                    {t('device.all')}
                </Link>
            </li>
        </ul>
    )
}

export default TableTabs
